export default __webpack_public_path__ + "static/media/L-A-Q.3713d8c8.png";